// Скачивание экспорта: GET /api/export → файл. Через fetch, чтобы показать ошибку, а не
// открыть страницу с JSON ошибки.

import { ApiError, apiUrl } from '@/api/client'
import { captureIdentity, IDENTITY_HEADER } from '@/api/identity'

export const EXPORT_FALLBACK_NAME = 'health-export.json'

/** Имя файла из Content-Disposition: attachment; filename="health-export-20261016.json". */
export function filenameFrom(disposition: string | null, fallback = EXPORT_FALLBACK_NAME): string {
  const match = disposition?.match(/filename="?([^";]+)"?/i)
  const name = match?.[1]?.trim()
  return name && /^[\w.-]+$/.test(name) ? name : fallback
}

export async function downloadExport(): Promise<{ filename: string; size: number }> {
  const identity = captureIdentity()
  if (!identity.id) throw new ApiError(401, 'unauthorized', 'Подтверди вход')
  let response: Response
  try {
    response = await fetch(apiUrl('/export'), { credentials: 'same-origin', headers: { Accept: 'application/json', [IDENTITY_HEADER]: identity.id } })
  } catch {
    throw new ApiError(0, 'network_error', 'Нет связи с сервером')
  }
  if (!identity.isCurrent()) throw new ApiError(409, 'identity_changed', 'Аккаунт изменился. Повтори экспорт после входа.')
  if (!response.ok) {
    let message = `Не получилось выгрузить данные (${response.status})`
    try {
      const body = (await response.json()) as { error?: { message?: string } }
      if (body.error?.message) message = body.error.message
    } catch {
      // не JSON — оставляем общий текст
    }
    throw new ApiError(response.status, 'export_failed', message)
  }
  const blob = await response.blob()
  if (!identity.isCurrent()) throw new ApiError(409, 'identity_changed', 'Аккаунт изменился. Повтори экспорт после входа.')
  const filename = filenameFrom(response.headers.get('Content-Disposition'))
  const url = URL.createObjectURL(blob)
  try {
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 1_000)
  }
  return { filename, size: blob.size }
}
